var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-tooltip"},[_c('Tooltip',_vm._g(_vm._b({},'Tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._t("content",null,{"slot":"content"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }